'use strict';

var Caml_option = require("bs-platform/lib/js/caml_option.js");

function getOptionValue(opt, fallback) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  } else {
    return fallback;
  }
}

function durationToString(millis) {
  if (millis < 1.0) {
    var micros = millis * 1000.0;
    if (micros === 0.0) {
      return "<1 ms";
    } else {
      return Math.floor(micros).toString() + " μs";
    }
  }
  if (millis < 1000.0) {
    return Math.floor(millis).toString() + " ms";
  }
  var secs = millis / 1000.0;
  return secs.toPrecision(3) + " s";
}

exports.getOptionValue = getOptionValue;
exports.durationToString = durationToString;
/* No side effect */
